import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";

import {
  FooterSection,
  Para,
  Language,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between" align="top">
            <Col lg={14} md={10} sm={12} xs={12}>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                <Language>{t("Nuestras oficinas")}</Language>
                <Para>Calle Mayor, 15bj, Burlada (31600), Navarra</Para>
                <Para>Calle Iturrama, 5bj, Pamplona (31007), Navarra</Para>
                <Para>Avenida de Orihuela 90, Alicante (03006), Comunidad Valenciana</Para>
                <Para>Calle Dos Bocas 6416, Ciudad de Panamá, Panamá</Para>
              </div>
            </Col>
            <Col lg={10} md={10} sm={12} xs={12}>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                <Language>{t("Contacto")}</Language>
                <Para>{t("¿Tienes alguna pregunta? No dudes en contactar con nuestro personal.")}</Para>
              </div>
            </Col>
          </Row>
          <Row justify="end" style={{ marginTop: "2rem" }}>
            <Para style={{ fontSize: "0.8rem", textAlign: "right" }}>
              &copy; Kevhel 2025
            </Para>
          </Row>
        </Container>
      </FooterSection>

    </>
  );
};

export default withTranslation()(Footer);
